var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-09-20
 * @brief EHP 메뉴 관리 개발
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../../recoil/userState";
import { loadingBoxState } from "../../../../recoil/menuState";
// utils
import clog from "../../../../utils/logUtils";
import * as CONST from "../../../../utils/Const";
import * as CUTIL from "../../../../utils/commUtils";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
//component
import EhpPagination from "../../../common/pagination/EhpPagination";
import MenuCombo from "../common/MenuCombo";
/**
 * @brief EHP 메뉴 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function LangSetting(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props
    const isMobile = props.isMobile;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    //화면 이동
    const navigate = useNavigate();
    //
    const [menuList, setMenuList] = useState([]);
    const defaultPageInfo = { "size": 10, "totalElements": 0, "totalPages": 0, "number": 0, "psize": 10 };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    const [codeParam, setCodeParam] = useState("");
    let appPath = "";
    appPath = 'page=' + pageInfo.number + '&size=' + pageInfo.size;
    if (codeParam.length > 0) {
        appPath = appPath + "&menuCode=" + codeParam;
    }
    const [menuListReload, setMenuListReload] = useState(false);
    const [errorList, setErrorList] = useState([]);
    //{menuCode, menuName, errList : {}}
    //[{"field":"menuName","msg":"필수 항목입니다."}]
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/menus?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: selTree + appPath + menuListReload
        //watch: selTree.company.companyId+selTree.reload
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
        if (ERR_URL.length > 0) {
            setRecoilIsLoadingBox(false);
            navigate(ERR_URL);
        }
        if (retData) {
            //clog("IN LANG SETTING : RES : " + JSON.stringify(retData));
            if (retData.codeNum == CONST.API_200) {
                setRecoilIsLoadingBox(false);
                setMenuListReload(false); // list reload
                setIsEditable(false);
                setMenuList(retData.body);
                setPageInfo(Object.assign(Object.assign({}, retData.data.page), { psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT })); //5, 10
                setErrorList([]);
            }
        }
    }, [selTree, retData]);
    const [isEditable, setIsEditable] = useState(false);
    function onClickDoSaveLangSetting(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const errList = [];
            var doCnt = 0;
            var doneCnt = 0;
            var succCnt = 0;
            var ret = confirm("변경 내용을 저장하시겠습니까?");
            if (!ret)
                return;
            setRecoilIsLoadingBox(true);
            menuList.map((menu) => __awaiter(this, void 0, void 0, function* () {
                clog("EACH SAVE DONE : " + menu.menuCode + " : " + menu.depthName1 + "/" + menu.depthName2);
                // 영어
                let data = null;
                doCnt++;
                data = yield doSaveEnglishLangSetting(menu);
                if (data) {
                    doneCnt++;
                    if (data.codeNum === CONST.API_200) {
                        succCnt++;
                    }
                    else {
                        errList.push({ menuCode: menu.menuCode, menuNameField: CONST.STR_APILANG_ENG, errList: data.body.errorList });
                    }
                    // 중국어
                    let cdata = null;
                    doCnt++;
                    CUTIL.sleep(500);
                    cdata = yield doSaveChineseLangSetting(menu);
                    if (cdata) {
                        doneCnt++;
                        if (cdata.codeNum == CONST.API_200) {
                            succCnt++;
                        }
                        else {
                            errList.push({ menuCode: menu.menuCode, menuNameField: CONST.STR_APILANG_CHA, errList: cdata.body.errorList });
                        }
                        if (doneCnt === (menuList.length * 2)) {
                            setErrorList(errList);
                            if (doCnt === succCnt) {
                                alert("저장되었습니다.");
                                setMenuListReload(true); // reload
                            }
                            else {
                                alert("저장 중 오류가 발생했습니다. 오류내역을 확인하세요.");
                            }
                            doneCnt = 0;
                            setRecoilIsLoadingBox(false);
                        }
                    }
                }
                CUTIL.sleep(500);
            }));
        });
    }
    function doSaveEnglishLangSetting(menu) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "POST",
                "appPath": `/api/v2/menu`,
                appQuery: {
                    "menuCode": menu.menuCode,
                    "menuName": CUTIL.isnull(menu.menuEnglish) ? "" : menu.menuEnglish,
                    "language": CONST.STR_APILANG_ENG,
                },
                userToken: userInfo.loginInfo.token,
            });
            return data;
        });
    }
    function doSaveChineseLangSetting(menu) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "POST",
                "appPath": `/api/v2/menu`,
                appQuery: {
                    "menuCode": menu.menuCode,
                    "menuName": CUTIL.isnull(menu.menuChinese) ? "" : menu.menuChinese,
                    "language": CONST.STR_APILANG_CHA,
                },
                userToken: userInfo.loginInfo.token,
            });
            return data;
        });
    }
    /*<!--220920 테이블 포커스 컬러-->
    <script type="text/javascript">
      function focuss(obj) {
        var i;
        var tabNum = obj.parentNode.children.length; //부모의 자식수. 즉, tbody의 tr의 갯수를 리턴합니다.
  
        for (i = 0; i < tabNum; i++) obj.parentNode.children[i].className = "";
        obj.className = "on"; //obj에는 클릭한 tr의 정보가 넘어옵니다.
      }
    </script>*/
    function onChangeEnglish(e, menuCode) {
        setMenuList(menuList.map((smenu) => (smenu.menuCode === menuCode)
            ? Object.assign(Object.assign({}, smenu), { menuEnglish: e.target.value }) : smenu));
    }
    function onChangeChinese(e, menuCode) {
        setMenuList(menuList.map((smenu) => (smenu.menuCode === menuCode)
            ? Object.assign(Object.assign({}, smenu), { menuChinese: e.target.value }) : smenu));
    }
    clog("ERROR LIST : LANG : " + JSON.stringify(errorList));
    //clog("ERR LIST : LANG : " + JSON.stringify(errList));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__right_content workplace__info workplace__main info__input newtype" },
            React.createElement("div", { className: "page-top" },
                React.createElement("h2", null, "\uB2E4\uAD6D\uC5B4 \uC124\uC815")),
            React.createElement("div", { className: "tbl__top mb-16" },
                React.createElement("div", { className: "left" },
                    React.createElement(MenuCombo, { selTree: props.selTree, setCodeParam: setCodeParam, setCurPage: handleCurPage })),
                React.createElement("div", { className: "right" },
                    (!isEditable) &&
                        React.createElement("button", { type: "button", className: "bg-gray", onClick: (e) => setIsEditable(true) },
                            React.createElement("span", null, "\uC218\uC815")),
                    (isEditable) && React.createElement("button", { type: "button", className: "bg-blue", onClick: (e) => onClickDoSaveLangSetting(e) },
                        React.createElement("span", null, "\uC800\uC7A5")))),
            React.createElement("div", { className: "tbl-list lang-list" },
                React.createElement("table", { summary: "\uBA54\uB274,\uC0C1\uC138\uBA54\uB274,English,\u4E2D\u6587 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uB2E4\uAD6D\uC5B4 \uC124\uC815 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "\uB2E4\uAD6D\uC5B4 \uC124\uC815 \uB9AC\uC2A4\uD2B8"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: { "width": "" } })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uBA54\uB274"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC0C1\uC138\uBA54\uB274"),
                            React.createElement("th", { scope: "col" }, "English"),
                            React.createElement("th", { scope: "col" }, "\u4E2D\u6587"))),
                    React.createElement("tbody", null, menuList.map((menu, idx) => (React.createElement("tr", { key: `tr_${idx.toString()}` },
                        React.createElement("td", { className: "txt-left" },
                            React.createElement("p", { className: "ellipsis" }, menu.depthName1)),
                        React.createElement("td", { className: "txt-left" },
                            React.createElement("p", { className: "ellipsis" }, menu.depthName2)),
                        React.createElement("td", null,
                            React.createElement("div", { className: `input__area ${(errorList.filter((err) => ((err.menuCode === menu.menuCode) && (err.menuNameField === CONST.STR_APILANG_ENG))).length > 0) ? "input-error" : ""}` },
                                React.createElement("input", { type: "text", placeholder: "Language", value: (CUTIL.isnull(menu.menuEnglish)) ? "" : menu.menuEnglish, disabled: (!isEditable) ? true : false, onChange: (e) => onChangeEnglish(e, menu.menuCode) }),
                                errorList.filter((err) => ((err.menuCode === menu.menuCode) && (err.menuNameField === CONST.STR_APILANG_ENG))).map((err) => (
                                //(err.hasOwnProperty("errList")&&err.errList.hasOwnProperty("filter"))&&
                                (err.errList) &&
                                    err.errList.filter((emsg) => (emsg.field === "menuName")).map((emsg, idx) => (React.createElement("p", { key: `p_${idx.toString()}`, className: "input-errortxt" }, emsg.msg))))))),
                        React.createElement("td", null,
                            React.createElement("div", { className: `input__area ${(errorList.filter((err) => ((err.menuCode === menu.menuCode) && (err.menuNameField === CONST.STR_APILANG_CHA))).length > 0) ? "input-error" : ""}` },
                                React.createElement("input", { type: "text", placeholder: "\u8BED\u8A00", value: (CUTIL.isnull(menu.menuChinese)) ? "" : menu.menuChinese, disabled: (!isEditable) ? true : false, onChange: (e) => onChangeChinese(e, menu.menuCode) }),
                                errorList.filter((err) => ((err.menuCode === menu.menuCode) && (err.menuNameField === CONST.STR_APILANG_CHA))).map((err) => (
                                //(err.hasOwnProperty("errList")&&err.errList.hasOwnProperty("filter"))&&
                                (err.errList) &&
                                    err.errList.filter((emsg) => (emsg.field === "menuName")).map((emsg, idx) => (React.createElement("p", { key: `p_${idx.toString()}`, className: "input-errortxt" }, emsg.msg))))))))))))),
            React.createElement(EhpPagination, { componentName: "LANGSETTING", pageInfo: pageInfo, handleFunc: handleCurPage }))));
}
;
export default LangSetting;
